import { get, post, put, destroy } from '.';

export function GetOrganizationUsers(options = {}) {
	return get<any>("/app/api/get_organization_users", options);
}

export function GetAllUsersInOrganization(options = {}) {
	return get<any>(`/app/api/organization_users/users`, options);
}

export function GetAvaliableOrganizationUsers(options = {}) {
	return get<any>(`/app/api/organization_users/available`, options);
}

export function CreateOrganizationUser(options = {}) {
	return post<any>(`/app/api/organization_users`, options);
}

export function AddAllAvailableOrganizationUsers(options = {}) {
	return post<any>(`/app/api/organization_users/all`, options);
}

export function UpdateOrganizationUser(id: string, options = {}) {
	return put<any>(`/app/api/organization_users/${id}`, options);
}

export function DestroyOrganizationUser(id: string, options = {}) {
	return destroy<any>(`/app/api/organization_users/${id}`, options);
}

export function RemoveAllOrganizationUsers(options = {}) {
	return destroy<any>(`/app/api/organization_users/all`, options);
}
